var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search page" }, [
      _c("div", { attrs: { id: "bg-image-wrapper" } }),
      _c("div", { staticClass: "featured-outer small" }),
      _c("main", { attrs: { role: "main" } }, [
        _c("h1", { staticClass: "title" }, [_vm._v("Search")]),
      ]),
      _c("div", { staticClass: "bottom-spacer" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }